/* eslint-disable */
/* tslint:disable */
/**
 * This file was automatically generated by build_schema.mjs.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run pnpm build_schema to regenerate this file.
 */
export const SCHEMA_IDS = [
  'dto/example',
  'entity',
  'entity/accounting/mercury_bank/transaction',
  'entity/accounting/mercury_bank/transaction/waveapps_sync',
  'entity/admin',
  'entity/client/duct_doctor',
  'entity/client/event',
  'entity/client/lead',
  'entity/debug_data',
  'entity/user',
  'entity/user/login_credentials',
  'entity/user/pipeline',
  'entity/user/pipeline_step',
  'entity/user/s3_file',
  'entity/user/user_debug_data',
] as const;

export type SchemaId = (typeof SCHEMA_IDS)[number];
export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
export type RegistryEntry<T extends $.Entity = $.Entity> = {
  $id: string;
  title: string;
  properties: {
    type: {
      const?: string;
      enum?: string[];
    };
  };
  new: (override?: DeepPartial<T>) => T;
};

export const dto_example = {
  $id: 'dto/example',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'ExampleDto',
  type: 'object',
  required: ['one', 'two'],
  properties: { one: { type: 'string' }, two: { type: 'string' } },
  additionalProperties: false,
  new: (override?: DeepPartial<$.ExampleDto>) => {
    const original = { one: '', two: '' };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.ExampleDto;
  },
};

export const entity = {
  $id: 'entity',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Entity',
  prefix: 'ENT',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: {
      type: 'string',
      enum: [
        'admin',
        'debug_data',
        'user',
        'login_credentials',
        'pipeline',
        'pipeline_step',
        's3_file',
        'user_debug_data',
        'client_duct_doctor',
        'client_event',
        'client_lead',
        'mercury_transaction',
        'waveapps_sync',
      ],
    },
    body: {
      anyOf: [{ type: 'object' }, { type: 'string' }, { type: 'number' }, { type: 'boolean' }, { type: 'null' }],
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.Entity>) => {
    const original = { type: 'admin' };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.Entity;
  },
};

export const entity_accounting_mercury_bank_transaction = {
  $id: 'entity/accounting/mercury_bank/transaction',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'MercuryTransaction',
  prefix: 'MTR',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'mercury_transaction' },
    body: {
      type: 'object',
      required: ['id', 'counterpartyName', 'amount', 'createdAt'],
      properties: {
        id: { type: 'string' },
        counterpartyName: { type: 'string' },
        amount: { type: 'number' },
        createdAt: { type: 'string' },
      },
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.MercuryTransaction>) => {
    const original = { type: 'mercury_transaction', body: { id: '', counterpartyName: '', amount: 0, createdAt: '' } };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.MercuryTransaction;
  },
};

export const entity_accounting_mercury_bank_transaction_waveapps_sync = {
  $id: 'entity/accounting/mercury_bank/transaction/waveapps_sync',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'WaveappsSync',
  prefix: 'WAS',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'waveapps_sync' },
    body: { type: 'object' },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.WaveappsSync>) => {
    const original = { type: 'waveapps_sync', body: {} };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.WaveappsSync;
  },
};

export const entity_admin = {
  $id: 'entity/admin',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Admin',
  prefix: 'ADM',
  type: 'object',
  required: ['type', 'body', 'id'],
  properties: {
    type: { const: 'admin' },
    body: {
      type: 'object',
      required: ['mercuryBank'],
      properties: {
        mercuryBank: {
          type: 'object',
          required: ['dataLoadInProgress', 'dataSyncInProgress', 'lastSuccessfulDataLoad', 'lastSuccessfulDataSync'],
          properties: {
            dataLoadInProgress: { type: 'boolean' },
            dataSyncInProgress: { type: 'boolean' },
            lastSuccessfulDataLoad: { type: 'string' },
            lastSuccessfulDataSync: { type: 'string' },
          },
          additionalProperties: false,
        },
      },
      additionalProperties: false,
    },
    id: { const: 'ADM_00000000000000000000' },
    owner_id: { const: null },
    external_id: { const: null },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.Admin>) => {
    const original = {
      type: 'admin',
      body: {
        mercuryBank: {
          dataLoadInProgress: false,
          dataSyncInProgress: false,
          lastSuccessfulDataLoad: '',
          lastSuccessfulDataSync: '',
        },
      },
      id: 'ADM_00000000000000000000',
    };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.Admin;
  },
};

export const entity_client_duct_doctor = {
  $id: 'entity/client/duct_doctor',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'ClientDuctDoctor',
  prefix: 'CDD',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'client_duct_doctor' },
    body: {
      type: 'object',
      required: ['oauth', 'selfClient'],
      properties: {
        oauth: {
          type: 'object',
          required: ['access_token', 'refresh_token', 'expiration', 'api_domain', 'token_type'],
          properties: {
            access_token: { type: 'string' },
            refresh_token: { type: 'string' },
            expiration: { type: 'string' },
            api_domain: { type: 'string' },
            token_type: { type: 'string' },
          },
          additionalProperties: false,
        },
        selfClient: {
          type: 'object',
          required: ['client_id', 'client_secret'],
          properties: { client_id: { type: 'string' }, client_secret: { type: 'string' } },
          additionalProperties: false,
        },
        isRefreshingAccessToken: { type: 'boolean' },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.ClientDuctDoctor>) => {
    const original = {
      type: 'client_duct_doctor',
      body: {
        oauth: { access_token: '', refresh_token: '', expiration: '', api_domain: '', token_type: '' },
        selfClient: { client_id: '', client_secret: '' },
      },
    };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.ClientDuctDoctor;
  },
};

export const entity_client_event = {
  $id: 'entity/client/event',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'ClientEvent',
  prefix: 'CLE',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'client_event' },
    body: {
      type: 'object',
      required: ['client', 'data'],
      properties: {
        client: { type: 'string', enum: ['duct_doctor', 'warranty_pilot'] },
        data: { oneOf: [{ type: 'array' }, { type: 'object' }] },
        additionalProperties: false,
      },
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.ClientEvent>) => {
    const original = { type: 'client_event', body: { client: 'duct_doctor' } };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.ClientEvent;
  },
};

export const entity_client_lead = {
  $id: 'entity/client/lead',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'ClientLead',
  prefix: 'CLD',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'client_lead' },
    body: {
      type: 'object',
      required: ['company', 'firstName', 'lastName', 'email', 'phone', 'budget', 'notes'],
      properties: {
        company: { type: 'string', minLength: 1, maxLength: 128 },
        firstName: { type: 'string', minLength: 1, maxLength: 64 },
        lastName: { type: 'string', minLength: 1, maxLength: 64 },
        email: {
          type: 'string',
          pattern:
            "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
        },
        phone: { type: 'string', pattern: '^[0-9]{3}-[0-9]{3}-[0-9]{4}$' },
        budget: { type: 'string', minLength: 0, maxLength: 16 },
        notes: { type: 'string', maxLength: 16383 },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.ClientLead>) => {
    const original = {
      type: 'client_lead',
      body: { company: '', firstName: '', lastName: '', email: '', phone: '', budget: '', notes: '' },
    };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.ClientLead;
  },
};

export const entity_debug_data = {
  $id: 'entity/debug_data',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'DebugData',
  prefix: 'DBG',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'debug_data' },
    body: {
      type: 'object',
      required: ['type', 'data'],
      properties: {
        type: { type: 'string' },
        data: {
          anyOf: [{ type: 'object' }, { type: 'string' }, { type: 'number' }, { type: 'boolean' }, { type: 'null' }],
          tsType: 'any',
        },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.DebugData>) => {
    const original = { type: 'debug_data', body: { type: '' } };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.DebugData;
  },
};

export const entity_user = {
  $id: 'entity/user',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'User',
  prefix: 'USR',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'user' },
    body: {
      type: 'object',
      required: ['email'],
      properties: {
        email: { type: 'string' },
        stockUnlock: {
          type: 'object',
          required: ['authorizationCode', 'dataSyncInProgress', 'lastSuccessfulDataSync'],
          properties: {
            authorizationCode: { type: 'string' },
            dataSyncInProgress: { type: 'boolean' },
            lastSuccessfulDataSync: { type: 'string' },
          },
          additionalProperties: false,
        },
        stripe: {
          type: 'object',
          required: ['stripeSubscriptionStatus'],
          properties: {
            stripeSubscriptionId: { type: 'string' },
            stripeCustomerId: { type: 'string' },
            stripePriceId: { type: 'string' },
            stripeSubscriptionStatus: { type: 'string', enum: ['active', 'inactive'], default: 'inactive' },
          },
          additionalProperties: false,
        },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.User>) => {
    const original = { type: 'user', body: { email: '' } };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.User;
  },
};

export const entity_user_login_credentials = {
  $id: 'entity/user/login_credentials',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'LoginCredentials',
  prefix: 'LCR',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'login_credentials' },
    body: {
      type: 'object',
      required: ['passwordHash', 'refreshTokenHash'],
      properties: { passwordHash: { type: 'string' }, refreshTokenHash: { type: 'string' } },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.LoginCredentials>) => {
    const original = { type: 'login_credentials', body: { passwordHash: '', refreshTokenHash: '' } };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.LoginCredentials;
  },
};

export const entity_user_pipeline = {
  $id: 'entity/user/pipeline',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Pipeline',
  prefix: 'PLN',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'pipeline' },
    body: {
      type: 'object',
      required: ['trigger', 'status', 'steps', 'lastSuccessfulStep', 'currentStep', 'currentAttempt'],
      properties: {
        trigger: {
          type: 'object',
          required: ['event'],
          properties: {
            event: { enum: ['EntityUpsertedEvent', 'EntityDeletedEvent'] },
            type: { type: 'string', $comment: 'TODO: Describe what this type field refers to' },
          },
          additionalProperties: false,
        },
        status: { enum: ['queued', 'running', 'stopped', 'completed', 'failed'], default: 'stopped' },
        steps: { type: 'array', items: { type: 'string' } },
        currentStep: { type: 'number', default: 0 },
        currentAttempt: { type: 'number', default: 1 },
        lastSuccessfulStep: { type: 'number', default: -1 },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.Pipeline>) => {
    const original = {
      type: 'pipeline',
      body: {
        trigger: { event: 'EntityUpsertedEvent' },
        status: 'stopped',
        steps: [],
        currentStep: 0,
        currentAttempt: 1,
        lastSuccessfulStep: -1,
      },
    };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.Pipeline;
  },
};

export const entity_user_pipeline_step = {
  $id: 'entity/user/pipeline_step',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'PipelineStep',
  prefix: 'PLS',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'pipeline_step' },
    body: {
      type: 'object',
      required: ['pipeline_id', 'type', 'status', 'input', 'options'],
      properties: {
        pipeline_id: { type: 'string' },
        status: { enum: ['queued', 'running', 'stopped', 'completed', 'failed'], default: 'stopped' },
        input: {
          type: 'object',
          required: ['type', 'value'],
          properties: { type: { enum: ['text', 'file'] }, value: { type: 'string' } },
          additionalProperties: false,
        },
        output: { type: 'string' },
        options: {
          type: 'object',
          properties: {
            extract_text: {
              type: 'object',
              required: ['file_id'],
              properties: { file_id: { type: 'string' } },
              additionalProperties: false,
            },
            run_inference: {
              type: 'object',
              required: ['model'],
              properties: {
                model: { type: 'string' },
                prompt: {
                  type: 'string',
                  $comment: 'Include {OUTPUT} to inject output of previous step into the prompt',
                },
              },
              additionalProperties: false,
            },
          },
          additionalProperties: false,
        },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.PipelineStep>) => {
    const original = {
      type: 'pipeline_step',
      body: { pipeline_id: '', status: 'stopped', input: { type: 'text', value: '' }, options: {} },
    };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.PipelineStep;
  },
};

export const entity_user_s3_file = {
  $id: 'entity/user/s3_file',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'S3File',
  prefix: 'S3F',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 's3_file' },
    body: {
      type: 'object',
      required: ['key', 'bucket', 'name', 'type', 'size', 'ETag'],
      properties: {
        key: { type: 'string' },
        bucket: { type: 'string' },
        name: { type: 'string' },
        type: { type: 'string', description: 'This is the mimetype' },
        size: { type: 'number', description: 'Measured in bytes' },
        ETag: {
          type: 'string',
          description: 'This is the hash of the file: https://docs.aws.amazon.com/AmazonS3/latest/API/API_Object.html',
        },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.S3File>) => {
    const original = { type: 's3_file', body: { key: '', bucket: '', name: '', type: '', size: 0, ETag: '' } };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.S3File;
  },
};

export const entity_user_user_debug_data = {
  $id: 'entity/user/user_debug_data',
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'UserDebugData',
  prefix: 'UDD',
  type: 'object',
  required: ['type', 'body'],
  properties: {
    type: { const: 'user_debug_data' },
    body: {
      type: 'object',
      required: ['type', 'data'],
      properties: {
        type: { type: 'string' },
        data: {
          anyOf: [{ type: 'object' }, { type: 'string' }, { type: 'number' }, { type: 'boolean' }, { type: 'null' }],
          tsType: 'any',
        },
      },
      additionalProperties: false,
    },
    id: { type: 'string', minLength: 20, maxLength: 24 },
    owner_id: { anyOf: [{ type: 'string', minLength: 20, maxLength: 24 }, { const: null }], tsType: 'string | null' },
    external_id: { anyOf: [{ type: 'string', maxLength: 64 }, { const: null }], tsType: 'string | null' },
    status: { type: 'string', enum: ['active', 'inactive'], default: 'active' },
    version: { type: 'number', default: 1 },
    created_at: { type: 'string' },
    updated_at: { type: 'string' },
  },
  additionalProperties: false,
  new: (override?: DeepPartial<$.UserDebugData>) => {
    const original = { type: 'user_debug_data', body: { type: '' } };
    return (override != null ? merge(original, override) : original || {}) as unknown as $.UserDebugData;
  },
};

/**
 * WARNING:
 * Usage of this export will force all schemas to load, breaking any possibility to do tree-shaking.
 * It's fine to use on the server, but on the client it's better to import each schema object separately.
 */
export const schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  $id: 'v1',
  browserGlobal: 'schema',
  anyOf: [
    entity,
    entity_admin,
    entity_debug_data,
    entity_user,
    entity_user_login_credentials,
    entity_user_pipeline,
    entity_user_pipeline_step,
    entity_user_s3_file,
    entity_user_user_debug_data,
    entity_client_duct_doctor,
    entity_client_event,
    entity_client_lead,
    entity_accounting_mercury_bank_transaction,
    entity_accounting_mercury_bank_transaction_waveapps_sync,
    dto_example,
  ],
  $comment:
    "This was automatically generated by build_schema. WARNING: Usage of this export will force all schemas to load, breaking any possibility to do tree-shaking. It's fine to use on the server, but on the client it's better to import each schema object separately.",
};

/**
 * WARNING:
 * Usage of this export will force all schemas to load, breaking any possibility to do tree-shaking.
 * It's fine to use on the server, but on the client it's better to import each schema object separately.
 */
export function getSchema<T extends $.Entity = $.Entity>(id: SchemaId) {
  return {
    'dto/example': dto_example,
    entity: entity,
    'entity/accounting/mercury_bank/transaction': entity_accounting_mercury_bank_transaction,
    'entity/accounting/mercury_bank/transaction/waveapps_sync':
      entity_accounting_mercury_bank_transaction_waveapps_sync,
    'entity/admin': entity_admin,
    'entity/client/duct_doctor': entity_client_duct_doctor,
    'entity/client/event': entity_client_event,
    'entity/client/lead': entity_client_lead,
    'entity/debug_data': entity_debug_data,
    'entity/user': entity_user,
    'entity/user/login_credentials': entity_user_login_credentials,
    'entity/user/pipeline': entity_user_pipeline,
    'entity/user/pipeline_step': entity_user_pipeline_step,
    'entity/user/s3_file': entity_user_s3_file,
    'entity/user/user_debug_data': entity_user_user_debug_data,
  }[id] as unknown as RegistryEntry<T>;
}

export function merge<S, O>(...args: [S, O]): S & O {
  const [source, override] = args;
  if (typeof source !== 'object') {
    return (override ?? source) as S & O;
  }
  return args.reduce(
    (prev: any, obj: any) => {
      Object.keys(obj).forEach((key) => {
        const pVal = prev[key];
        const oVal = obj[key];
        const pType = Object.prototype.toString.call(pVal);
        const oType = Object.prototype.toString.call(oVal);

        if (pType === '[object Array]' && oType === '[object Array]') {
          prev[key] = pVal.concat(...oVal);
        } else if (pType === '[object Object]' && oType === '[object Object]') {
          prev[key] = merge(pVal, oVal);
        } else {
          prev[key] = oVal;
        }
      });
      return prev;
    },
    Array.isArray(source) ? [] : {},
  );
}

/**
 * WARNING:
 * Usage of this export will force all schemas to load, breaking any possibility to do tree-shaking.
 * It's fine to use on the server, but on the client it's better to import each schema object separately.
 */
export default {
  SCHEMA_IDS,
  dto_example,
  entity,
  entity_accounting_mercury_bank_transaction,
  entity_accounting_mercury_bank_transaction_waveapps_sync,
  entity_admin,
  entity_client_duct_doctor,
  entity_client_event,
  entity_client_lead,
  entity_debug_data,
  entity_user,
  entity_user_login_credentials,
  entity_user_pipeline,
  entity_user_pipeline_step,
  entity_user_s3_file,
  entity_user_user_debug_data,
  schema,
  merge,
  getSchema,
};
